var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.messagePreview,{tag:"component",attrs:{"message":_vm.message,"auth-user-id":_vm.authUserId}})}
var staticRenderFns = []

export { render, staticRenderFns }